export default __webpack_public_path__ + "fonts/cp_bg2.3ce8f2f88a7f34141588a864672d9129.png";